<template>
  <div class="process-time-per-phase-chart">
    <div class="filters">
      <label>Portal:</label>
      <select
        v-model="selectedPortal"
        class="filter-select"
        @change="fetchChartData"
      >
        <option value="">
          Todos
        </option>
        <option
          v-for="portal in portals"
          :key="portal"
          :value="portal"
        >
          {{ portal }}
        </option>
      </select>
    </div>

    <div class="chart-box">
      <bar-chart
        v-if="chartData"
        :chart-data="chartData"
        :options="chartOptions"
      />
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { reactiveProp } from 'vue-chartjs/es/mixins'
import fetchTimestampReportData from '@/syslic/dashboard/timestamp/timestampReportService'
import filterTimestampReportData from '@/syslic/dashboard/timestamp/filterTimestampReportData'

export default {
  name: 'ProcessTimePerPhaseChart',
  components: {
    barChart: {
      extends: Bar,
      mixins: [reactiveProp],
      props: ['chartData', 'options'],
      mounted() {
        this.renderChart(this.chartData, this.options)
      },
      watch: {
        chartData(newData) {
          this.renderChart(newData, this.options)
        },
      },
    },
  },
  data() {
    return {
      allData: [],
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          title: {
            display: true,
            text: 'Tempo Médio por Fase do Processo Licitatório (em dias)',
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            title: { display: true, text: 'Dias' },
          },
        },
      },
      portals: [],
      selectedPortal: '',
    }
  },
  async mounted() {
    this.allData = await fetchTimestampReportData(this)
    this.populateFilters()
    this.fetchChartData()
  },
  methods: {
    populateFilters() {
      const portalSet = new Set()
      this.allData.forEach(item => {
        if (item.portal) portalSet.add(item.portal)
      })
      this.portals = Array.from(portalSet).sort()
    },
    fetchChartData() {
      const filters = {
        portalSelecionado: this.selectedPortal,
      }
      this.chartData = filterTimestampReportData(this.allData, filters)
    },
  },
}
</script>

<style scoped>
.process-time-per-phase-chart {
  padding: 1rem;
}
.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
  justify-content: center;
  align-items: center;
}
.filter-select {
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
  max-width: 250px;
  width: 100%;
}
.chart-box {
  width: 100%;
  height: 400px;
}
</style>
